import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
// routes
import { PATH_CDSS } from '../routes/paths';
import LoadingCircle from 'src/components/LoadingCircle';
import { useAuthContext } from 'src/auth/useAuthContext';

// ----------------------------------------------------------------------

type GuestGuardProps = {
  children: ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
  const { isAuthenticated, isInitialized } = useAuthContext();
  
  if (isAuthenticated) {
    return <Navigate to={PATH_CDSS.hypotension} replace={true} />;
  }

  if (!isInitialized) {
    return <LoadingCircle />;
  }

  return <> {children} </>;
}
